export function usePendoEnrichment() {
  const { pendoEnabled } = useRuntimeConfig().public

  if (!import.meta.client || !isPendoEnabled(pendoEnabled)) {
    return
  }

  const { loggedIn } = useUserSession()
  const { updateOptions } = usePendo()

  const customerMeta = useCustomerMetadata()

  watch([customerMeta, loggedIn], ([meta, isLoggedIn]) => {
    if (!isLoggedIn || !meta) {
      return
    }

    if (!meta.subscriptionPackage) {
      return
    }

    updateOptions({
      account: {
        id: meta.customerNumber || 'unknown',
        name: meta.customerName || 'unknown',
        potentialUsers: meta.potentialUsers || 0,
        subscriptionStatus: meta.subscriptionStatus || null,
        subscriptionPackage: meta.subscriptionPackage,
      },
    })
  }, { immediate: true })
}
